const COMMON_PPREFIX = "store/filesReducer";

export const SET_PROCESSING = `${COMMON_PPREFIX}/SET_PROCESSING`;
export const FETCH_FILES = `${COMMON_PPREFIX}/FETCH_FILES`;
